// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_dynamodb_all_tables_region": "us-west-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "preference-center",
            "region": "us-west-2"
        }
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "apide08d634",
            "endpoint": "https://dev-api.constellationpreferences.com",
            "region": "us-west-2"
        }
    ]
};


export default awsmobile;



// WEBPACK FOOTER //
// ./src/aws-exports.js